import { InputHTMLAttributes, forwardRef, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Button from "./Button";
import Input from "./Input";

export interface PasswordInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  error?: boolean;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className = "", error, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword((prevState) => !prevState);
    };

    return (
      <div className="relative">
        <Input
          ref={ref}
          type={showPassword ? "text" : "password"}
          className={`${className} pr-10`}
          error={error}
          {...props}
        />
        <Button
          type="button"
          onClick={togglePasswordVisibility}
          variant="outline"
          className="absolute top-1/2 -translate-y-1/2 right-1 flex items-center z-20 px-2 py-1 h-auto cursor-pointer text-gray-400 rounded-md focus:outline-none focus:text-blue-600 border-0"
          disabled={props.disabled}
        >
          {showPassword ? <FaEye /> : <FaEyeSlash />}
        </Button>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
